import RadioButton from 'components/shared/RadioButton';
import { Heading1, Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useState } from 'react';
import AverageSalaryByLanguage from './charts/AverageSalaryByLanguage';
import AverageSalaryByRole from './charts/AverageSalaryByRole';
import AverageSalaryByTechnology from './charts/AverageSalaryByTechnology';
import OfferedPerks from './OfferedPerks';
import {
  StyledContainer,
  StyledHeader,
  StyledSection,
  StyledSubsection,
  StyledSubsectionHeader,
  StyledSwitcher
} from './SalariesSection.styled';

const SalariesSection: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const [averageByLang, setAverageByLang] = useState(true);

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeader>
          <Heading1 as="h2" editorial>
            {t('salaries.title')}
          </Heading1>
          <p>{t('salaries.desc')}</p>
        </StyledHeader>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('salaries.average-by-language.title')}</Heading3>
            <p>{t('salaries.average-by-language.desc')}</p>
          </StyledSubsectionHeader>
          <StyledSwitcher>
            <RadioButton
              name="averageByLang"
              id="averageByLang"
              label={t('salaries.average-by-language.switcher.languages')}
              onChange={() => setAverageByLang(true)}
              checked={averageByLang}
            />
            <RadioButton
              name="averageByLang"
              id="averageByTech"
              label={t('salaries.average-by-language.switcher.technologies')}
              onChange={() => setAverageByLang(false)}
              checked={!averageByLang}
            />
          </StyledSwitcher>
          {averageByLang && <AverageSalaryByLanguage />}
          {!averageByLang && <AverageSalaryByTechnology />}
        </StyledSubsection>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('salaries.average-by-role.title')}</Heading3>
            <p>{t('salaries.average-by-role.desc')}</p>
          </StyledSubsectionHeader>
          <AverageSalaryByRole />
        </StyledSubsection>
        <OfferedPerks />
      </StyledContainer>
    </StyledSection>
  );
};

export default SalariesSection;
